<section class="emperor-ui-no-quotes">
  <h3>{{ headerText }}</h3>
  <hr class="emperor-ui-divider" />
  <div class="emperor-ui-help-text-container">
    <emperor-icon name="operator_male"></emperor-icon>
    <div class="emperor-ui-help-text" [innerHTML]="helpHtml"></div>
  </div>
</section>
